import { render } from "./Form.vue?vue&type=template&id=6d65f3df&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=6d65f3df&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6d65f3df"

export default script